import React from "react";
import product from "../assets/product.png";
import heart from "../assets/heart.png";
import { HeartFilled, PlusOutlined } from "@ant-design/icons";


const Product2 = () => {
  return (
    <div className="bg-[#172e57] rounded-3xl px-7 pt-4 pb-7">
      <div className="relative">
        <img
          src={product}
          className="rounded-3xl w-[250px] h-[220px] mx-auto"
        />
        <div className="bg-[#FCFBFA] w-[40px] h-[40px] mx-auto flex items-center rounded-full absolute top-5 right-8"><img src={heart} className="text-[#fe6625] mx-auto w-[19px]"/></div>
      </div>
      <div className="flex items-center justify-between px-3 mt-4">
        <div>
          <p className="text-[#F3F5F7]">Cage Lamp</p>
          <p className="text-[#DDE5ED] font-semibold text-xl">1546 SR</p>
        </div>
        <button className="bg-[#FE9B71] text-white flex items-center px-7 py-2 rounded-full font-semibold">
          Add <PlusOutlined className="ml-4" />
        </button>
      </div>
    </div>
  );
};

export default Product2;
